import { render, staticRenderFns } from "./balancAppAcountFlow.vue?vue&type=template&id=6d1f4c2c&"
import script from "./balancAppAcountFlow.vue?vue&type=script&lang=js&"
export * from "./balancAppAcountFlow.vue?vue&type=script&lang=js&"
import style0 from "./balancAppAcountFlow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports